import { useCallback } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Formik } from 'formik';
import { push } from 'redux-first-history';
import { Form } from '@client/components/forms/Form';
import { DirtyPrompt } from '@client/components/common/DirtyPrompt';
import { Button } from '@client/components/common/Button';
import { useDispatch } from '@client/hooks/redux.hooks';
import { getNextPageUrl } from '../utils';
import type { StepFormWrapperProps } from '@client/components/common/StepFormWrapper/interfaces';
import type { ScopedButtonProps } from '@client/components/common/Button/interfaces';
import type { FormikConfig, FormikProps } from 'formik';
import { SignupWrapper } from '.';

const useStyles = makeStyles()({
  form: {
    height: '100%',
  },
});

interface SignupWrapperFormProps<T> {
  readonly FormikProps: FormikConfig<T>;
  readonly buttonLabel?: string;
  readonly buttonProps: (props: FormikProps<T>) => ScopedButtonProps;
}

export const SignupWrapperForm = <T extends Record<string, any>>({
  FormikProps, buttonProps,
  buttonLabel = 'Next', ...restProps
}: SignupWrapperFormProps<T> & StepFormWrapperProps) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();

  const handleRedirect = useCallback(() => {
    dispatch(push(getNextPageUrl()));
  }, [dispatch]);

  return (
    <Formik {...FormikProps}>
      {(props) => {
        const ButtonProps = buttonProps ? buttonProps(props) : {};

        return (
          <Form className={classes.form}>
            <DirtyPrompt />

            <SignupWrapper
              {...restProps}
              renderToolbar={(
                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  scope="no-scope"
                  onSuccess={handleRedirect}
                  onError={() => props.setSubmitting(false)}
                  {...ButtonProps}
                >
                  {buttonLabel}
                </Button>
              )}
            />
          </Form>
        );
      }}
    </Formik>
  );
};
